var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGasStation = function SvgGasStation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m438 512h-380c-14.337 0-26-11.664-26-26v-44c0-14.336 11.663-26 26-26h380c14.337 0 26 11.664 26 26v44c0 14.336-11.663 26-26 26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181 128h134c2.761 0 5-2.239 5-5v-54c0-2.761-2.239-5-5-5h-134c-2.761 0-5 2.239-5 5v54c0 2.761 2.239 5 5 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208 296c0 22.056 17.944 40 40 40s40-17.944 40-40c0-13.004-18.097-41.739-36.014-65.482-1.993-2.641-5.971-2.64-7.964.001-17.917 23.757-36.022 52.503-36.022 65.481z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.155 89.689-55.155-27.578v-16.111c0-25.405-20.595-46-46-46h-244c-25.405 0-46 20.595-46 46v333c0 2.761 2.239 5 5 5h326c2.761 0 5-2.239 5-5v-13.797l41.814-57.494c14.514-19.959 22.186-43.551 22.186-68.228v-135.481c0-6.061-3.424-11.601-8.845-14.311zm-223.155 278.311c-39.7 0-72-32.3-72-72 0-16.38 10.1-38.86 30.86-68.73 14.31-20.58 28.42-37.02 29.01-37.71 3.04-3.53 7.47-5.56 12.13-5.56s9.09 2.03 12.13 5.56c.59.69 14.7 17.13 29.01 37.71 20.76 29.87 30.86 52.35 30.86 68.73 0 39.7-32.3 72-72 72zm104-234c0 14.34-11.66 26-26 26h-156c-14.34 0-26-11.66-26-26v-76c0-14.34 11.66-26 26-26h156c14.34 0 26 11.66 26 26zm96 105.481c0 17.869-5.556 34.954-16.065 49.407l-15.935 21.91v-212.909l32 16z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGasStation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gas-station.0ef90e04.svg";
export { ForwardRef as ReactComponent };